// Pe ce fel de aparat suntem.
//
// Nu e „adaptiv": nu întindem aceeaşi pagină pe un ecran mai îngust, ci pornim o altă
// interfaţă — meniu jos, foi care urcă de la marginea de jos, ecrane pe tot ecranul.
// Un telefon nu e un monitor mic; e altă postură a mâinii şi altă distanţă de citit.
//
// Decizia se ia **o dată**, la pornire, şi nu se schimbă la redimensionare. O aplicaţie
// care îşi schimbă felul în timp ce roteşti telefonul îţi pierde locul din pagină şi
// starea din formulare.

const CHEIE = 'sx_versiune';

/** Alegerea omului, dacă a făcut una. Poate lipsi: în mod privat nu se poate scrie. */
function alegerea() {
  try { return localStorage.getItem(CHEIE); } catch { return null; }
}

/**
 * Suntem pe telefon?
 *
 * Trei semne, nu unul: lăţimea singură ar prinde o fereastră de browser îngustată pe
 * un laptop, iar `user-agent`-ul singur minte de douăzeci de ani. Cerem şi ecran îngust,
 * şi lipsa unui indicator fin (mouse) — sau un `user-agent` limpede de telefon.
 */
export function esteMobil() {
  const ales = alegerea();
  if (ales) return ales === 'mobil';
  return pareMobil();
}

/** Ce arată aparatul, fără să ţinem cont de alegerea omului. */
export function pareMobil() {
  const ingust = window.matchMedia('(max-width: 860px)').matches;
  const degete = window.matchMedia('(pointer: coarse)').matches;
  const agent = /Android|iPhone|iPad|iPod|Mobile|Silk/i.test(navigator.userAgent);
  return (ingust && degete) || (agent && ingust);
}

/** Ce a ales omul, dacă a ales ceva: „mobil", „desktop" sau nimic. */
export function versiuneaAleasa() {
  return alegerea();
}

/** Trecerea manuală dintr-o versiune în alta. Reîncarcă: shell-ul se construieşte o dată. */
export function alegeVersiune(care) {
  try { localStorage.setItem(CHEIE, care); } catch { /* mod privat — atunci doar de data asta */ }
  location.reload();
}

/** Marginile pe care le mănâncă crestătura şi bara de gesturi, pentru padding. */
export function porneste() {
  document.body.classList.toggle('mobil', esteMobil());
  // `100vh` pe telefon include bara de adrese care se ascunde la derulare, deci un
  // ecran „plin" iese mai înalt decât ecranul. Ne ţinem singuri unitatea, în pixeli.
  const inaltime = () => {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
  };
  inaltime();
  window.addEventListener('resize', inaltime);
  window.addEventListener('orientationchange', () => setTimeout(inaltime, 120));
}
